import React from "react";
import { useNavigate } from "react-router-dom";
import StripeFormAndDetails from "../../../components/stripeFormAndDetails/StripeFormAndDetails";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";

const StudentCheckout = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h3
              className="ah-heading-04 fw-bold me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
              onClick={goBack}
            >
              <span aria-label="Back">
                <span className="icon-arrow-left"></span>
              </span>
              Checkout
            </h3>
          </div>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <span className="icon-bell notification-bell theme-color cursor-pointer"></span>
          </div>
        </div>
      </div>
      <div className="checkout-content">
        <StripeFormAndDetails />
      </div>
    </>
  );
};

export default StudentCheckout;
